<template lang="pug">
  v-btn(v-bind="$attrs" :loading="loading" v-on="listeners")
    slot(name="success" v-if="isSuccess") Success!
    slot(name="error" v-else-if="hasError") Error...
    slot(name="confirmation" v-else-if="hasConfirmation") Are you sure?
    slot(v-else)
    template(v-slot:loader)
      slot(name="loader")
        v-progress-circular(indeterminate)
</template>

<script>
export default {
  props: {
    confirm: { type: Boolean, default: false },
    time: { type: Number, default: 5000 },
    validator: { type: Object },
    valid: { type: Boolean, default: true },
    skipSuccess: { type: Boolean, default: false }
  },
  data: () => ({
    loading: false,
    hasConfirmation: false,
    isSuccess: false,
    hasError: false
  }),
  methods: {
    handleClick(event) {
      if(this.isValid)
        if(this.confirm && !this.hasConfirmation)
          this.resetDelayed('hasConfirmation')
        else {
          this.loading = true
          return Promise.resolve(this.$listeners.click(event))
            .then(() => { if(!this.skipSuccess) this.resetDelayed('isSuccess') })
            .catch(() => { this.resetDelayed('hasError') })
            .finally(() => { this.loading = false })
        }
    },
    resetDelayed(property) {
      this[property] = true
      setTimeout(() => {
        this[property] = false
      }, this.time)
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        click: this.handleClick
      }
    },
    isValid() {
      if(this.validator)
        this.validator.validate()
      return this.valid || (this.validator && this.validator._props.value)
    }
  }
}
</script>